import Video from 'app/components/tv/models/video';
import VideoCreator from 'app/components/tv/models/VideoCreator';
import Competition from 'app/components/tv/models/competition';
import {UserResource} from 'app/components/tv/apiResources/UserResource';
import {ApiVideo} from 'app/components/tv/apiResources/apiVideo';

export default class Playlist {
  private videos: Video[] = [];

  static createByApi(data: ApiVideo[]): Playlist {
    const playlist = new Playlist();
    data.forEach(video => playlist.addVideo(VideoCreator.createVideo(video)));
    return playlist;
  }

  static createByVideoList(videos: Video[]): Playlist {
    const playlist = new Playlist();
    videos.forEach(video => playlist.addVideo(video));
    return playlist;
  }

  addVideo(video: Video): void {
    this.videos.push(video);
  }

  findBySlug(slug: string): Video {
    const video = this.videos.find(elem => elem.slug === slug);
    if (!video) {
      throw new Error('Invalid video slug');
    }
    return video;
  }

  findByIndex(index: number): Video | null {
    return this.videos[index] ?? null;
  }

  getPlaylistId(): number {
    return this.getFirstVideo().matchPlaylistId;
  }

  getPlaylistSlug(): string {
    return this.getFirstVideo().matchPlaylist;
  }

  getFirstVideo(): Video {
    if (!this.hasVideos()) {
      throw new Error('No videos in playlist');
    }
    return this.videos[0];
  }

  getLastVideo(): Video {
    if (!this.hasVideos()) {
      throw new Error('No videos in playlist');
    }
    return this.videos[this.videos.length - 1];
  }

  hasVideos(): boolean {
    return this.videos.length > 0;
  }

  indexOf(video: Video): number {
    return this.videos.findIndex(elem => elem.slug === video.slug);
  }

  getDistrictEntity(): UserResource | Competition | null {
    const firstVideo = this.getFirstVideo();
    if (firstVideo.user?.district?.slug) {
      return firstVideo.user;
    }
    if (!firstVideo.match) {
      return null;
    }
    return firstVideo.match.competition;
  }

  getCreatorName(): string {
    const firstVideo = this.getFirstVideo();
    return firstVideo.user ? firstVideo.user.name : 'Unbekannter Nutzer';
  }

  allowWebsocket(): boolean {
    const firstVideo = this.getFirstVideo();
    if (!firstVideo.match) {
      return false;
    }
    const matchIsNotPast = !(firstVideo.match.matchModel.result.isInPast() ?? true);
    const isFuPaTv = firstVideo.match.isFuPaTv();
    return matchIsNotPast && isFuPaTv;
  }

  getVideos(): Video[] {
    return this.videos;
  }

  length(): number {
    return this.videos.length;
  }

  getEditUrl(): string {
    return `${process.env.ADMIN_URL}/fupa/admin/index.php?page=user_video&mavi_id=${this.getPlaylistId()}&aktion=edit`;
  }
}
